import StoreTags from '@enums/StoreTags'
import emptySplitApi from '../api'

export type CourseAuthorOption = {
  id: string | number
  name: string
}

const BASE_URL = '/api/course-authors'

export const courseAuthorsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getCourseAuthors: builder.query<CourseAuthorOption[], void>({
      query: () => BASE_URL,
      providesTags: [StoreTags.COURSE_AUTHORS],
    }),
  }),
})

export const { useGetCourseAuthorsQuery } = courseAuthorsApi
